import { FeatureData, featuresStorage } from '@bees-web/core/shared'
import { useFeatureFlags } from '@bees-web/core/shared/contexts'
import { useEffect } from 'react'

/** @deprecated Use FeatureFlagsProvider instead */
export function useGlobalFeatureFlags() {
  const featureFlags = useFeatureFlags()

  useEffect(() => {
    if (featureFlags) {
      featuresStorage().setData(featureFlags as unknown as FeatureData)
    }
  }, [featureFlags])
}
